import {Dispatch} from "react";

import { useBatteryService } from "../hooks/useBatteryService";
import { Header, LanguageSwitchType } from "@npd-ng/adp-benchmark";
import LowBatterWarning from "./BatteryWarning";
import { Content } from "../types/Content";
import { IADPState, IHeaderState, actions } from "../state";
import { IADPActions, IADPHeaderActions } from "../state/Actions";
import { useContentService } from "../hooks/useContentService";

export default function AppHeader(props:{dispatch:Dispatch<IADPActions>,state: IADPState,dispatchHeader:Dispatch<IADPHeaderActions>, headerState:IHeaderState}){
    const {fetchContent}= useContentService(props.dispatch);
    const content = props.state.staticContent as Content;
        useBatteryService(props.dispatchHeader,props.dispatch);
      
    const onExit = ()=>{
        window.close();
    };
    const onLanguageSwitch = (locale:LanguageSwitchType["selectedLocale"])=>{
        console.log("languageSwitch",locale);
        props.dispatchHeader(actions.createSetSelectedLocaleAction(locale as any));
        fetchContent(locale);
    };
    const getRouterType = ():any =>{
        switch (props.state.sessionState.networkConnectionState) 
        {
            case "online":
                return content.connectionType.wifi;
            case "offline":
                return content.connectionType.notApplicable;
            case "router":
                return content.connectionType.naepRouter;
        }
    }
    const connectionMode = {
        text: content.connectionModeText,
        routerState: getRouterType()
    }
    const languageProps:LanguageSwitchType = {
    selectedLocale:props.headerState.selectedLocale,
    content:{instructions:content?.language?.instructions,
    switch: {englishVersion: content?.language?.english, spanishVersion:content?.language?.spanish},
    },
    action:onLanguageSwitch
    }
    return (
        <>
        <LowBatterWarning 
        content = {content} 
        showBatteryWarning = {props.headerState.showBatteryWarning}
        dispatch = {props.dispatchHeader}
        />   
        <Header 
        ConnectionState={props.headerState.networkConnectionState} 
        BatteryLevel={props.headerState.batteryState} exitAction={onExit}
        LanguageSwitch={languageProps}
        connectionMode={connectionMode}
        />
        </>
    )
}